import React from "react";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

const CloseDialogButton = (props) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="contained"
      startIcon={<ClearIcon style={{fontSize: "2rem"}}/>}
      color="secondary"
      onClick={props.onClick}
      style={{ fontSize: "2rem"}}
    >
      {t("Close")}
    </Button>
  );
};

export default CloseDialogButton;
